import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeading } from './Features';

const QA = [
  {
    q: 'Where is my recovery phrase stored?',
    a: 'Nowhere but with you. Vela never transmits your mnemonic or decrypted keys anywhere. The encrypted vault lives in your browser’s local storage, sealed with a password only you know.',
  },
  {
    q: 'Which network does Vela support?',
    a: 'Vela is built specifically for the Midnight network, mainnet-first. Testnets and other developer environments are available behind an opt-in developer mode.',
  },
  {
    q: 'Has Vela been audited?',
    a: 'Not yet, and we’d rather say that plainly than imply otherwise. Vela is audit-pending: it already behaves like a locked-down wallet, but mainnet-scale distribution waits on an external security audit and manual release verification.',
  },
  {
    q: 'What happens if I lose my device?',
    a: 'As long as you have your recovery phrase, you can restore your accounts on any Chromium browser. Without it, no one — including us — can recover the vault, by design.',
  },
  {
    q: 'Does Vela cost anything?',
    a: 'No. Vela is free to install and use.',
  },
];

export function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="relative border-t border-white/[0.05] bg-midnight-900/40 py-28">
      <div className="mx-auto max-w-3xl px-6">
        <SectionHeading eyebrow="Questions" title="Before you install." align="center" />

        <div className="mt-14 divide-y divide-white/[0.06] border-y border-white/[0.06]">
          {QA.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q}>
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-6 py-5 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="text-base text-star sm:text-lg">{item.q}</span>
                  <span
                    className={`flex-none text-xl text-teal-soft transition-transform duration-300 ${
                      isOpen ? 'rotate-45' : ''
                    }`}
                    aria-hidden="true"
                  >
                    +
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pb-6 text-sm leading-relaxed text-mist">{item.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
